import { useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'
import { UpdateCouplePlanningDto } from 'src/dto/couple-planning.dto'
import { useGetCouplePlanningList } from 'src/hooks/api/couple-planning'
import { useUpdateCouplePlanning } from 'src/hooks/api/couple-planning'
import { useGetFarmList } from 'src/hooks/api/farm'
import { useGetLotList } from 'src/hooks/api/lot'
import ROUTES from 'src/constants/routes'

export function useRegisterCouplePlanning() {
  const [multipleRegisterCouple, setMultipleRegisterCouple] = useState<boolean>(false)
  const { id: registerCoupleId } = useParams()

  const { reset, handleSubmit } = useFormContext<UpdateCouplePlanningDto>()
  const navigate = useNavigate()

  const { data: couplePlanningList, isLoading: isLoadingCouplePlanning } = useGetCouplePlanningList()
  const { data: propertyList, isLoading: isLoadingPropertyList } = useGetFarmList()
  const { data: lotList, isLoading: isLoadingLotList } = useGetLotList()

  const { mutateAsync: updateCouplePlanning, isPending: isLoadingUpdateCouplePlanning } = useUpdateCouplePlanning()

  const registerCoupleData = useMemo(() => {
    return couplePlanningList?.find((item) => item.id === registerCoupleId)
  }, [couplePlanningList, registerCoupleId])

  const onSubmit = handleSubmit(async (formData: UpdateCouplePlanningDto) => {
    try {
      await updateCouplePlanning(formData)
      toastSyncSuccess(`Item ${formData.idProcesso ? 'atualizado' : 'salvo'} com sucesso!`)
    } catch (err: any) {
      toast.error(`Não foi possivel ${formData.idProcesso ? 'atualizar' : 'salvar'} os dados, tente novamente.`)
    }

    if (multipleRegisterCouple) {
      reset()
    } else {
      navigate(ROUTES.COUPLE_PLANNING.ROOT)
    }
  })

  useEffect(() => {
    if (registerCoupleData) {
      reset(registerCoupleData)
    }
  }, [registerCoupleData])

  return {
    isLoading: isLoadingCouplePlanning || isLoadingPropertyList || isLoadingLotList || isLoadingUpdateCouplePlanning,
    registerCoupleData,
    setMultipleRegisterCouple,
    lotList,
    propertyList,
    multipleRegisterCouple,
    onSubmit
  }
}
